<script setup lang="ts">
import ModalPageWrapper from '@modules/core/components/ModalPageWrapper/ModalPageWrapper.vue';

import type {
  IAffiliatePaymentSystemDialogEmits,
  IAffiliatePaymentSystemDialogProps,
  IAffiliatePaymentSystemDialogSlots,
} from './types';

defineProps<IAffiliatePaymentSystemDialogProps>();
const emit = defineEmits<IAffiliatePaymentSystemDialogEmits>();
defineSlots<IAffiliatePaymentSystemDialogSlots>();

const visible = defineModel<boolean>('visible');

function onHide(): void {
  visible.value = false;
  emit('hide');
}
</script>

<template>
  <div v-data-qa-auto-id="'AffiliatePaymentSystemDialog'">
    <ModalPageWrapper
      :show-dialog="visible"
      :back-to="backToRoute"
      :size="size"
      @hide="onHide"
    >
      <div>
        <div class="px-6 py-4">
          <div
            v-if="title"
            class="mb-6 pr-10 text-xl font-medium word-break"
            :class="{ 'input-max-width': !($slots.rightSide && $slots.leftSide) }"
          >
            {{ title }}
          </div>
          <div
            v-if="$slots.info"
            class="mb-4"
          >
            <slot name="info" />
          </div>
          <div class="flex flex-col gap-6 sm:flex-row sm:place-items-start">
            <div
              v-if="$slots.leftSide"
              class="order-last sm:order-first"
              :class="{
                'sm:w-1/2': $slots.rightSide,
                'w-full': !$slots.rightSide,
                'top-0 sm:sticky': stickySides,
              }"
            >
              <div
                v-if="leftColumnTitle || $slots.leftSideTitle"
                class="mb-2 pt-2 text-muted-color input-max-width word-break "
              >
                <slot
                  name="leftSideTitle"
                  :title="leftColumnTitle"
                >
                  {{ leftColumnTitle }}
                </slot>
              </div>
              <div>
                <slot name="leftSide" />
              </div>
            </div>
            <div
              v-if="$slots.rightSide"
              :class="{
                'sm:w-1/2': $slots.leftSide,
                'w-full': !$slots.leftSide,
                'top-0 sm:sticky': stickySides,
              }"
            >
              <div
                v-if="rightColumnTitle || $slots.rightSideTitle"
                class="mb-2 pt-2 text-muted-color input-max-width word-break"
              >
                <slot
                  name="rightSideTitle"
                  :title="rightColumnTitle"
                >
                  {{ rightColumnTitle }}
                </slot>
              </div>
              <div>
                <slot name="rightSide" />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="$slots.footer"
          class=" px-6 py-4"
          :class="{ 'sticky bottom-0 z-10 bg-white': stickyFooter }"
        >
          <slot name="footer" />
        </div>
      </div>
    </ModalPageWrapper>
  </div>
</template>
